export const checkTabId = () => {
  if (typeof window === "undefined") return;
  const epochDateTime = Date.now();
  sessionStorage.setItem("tabId", epochDateTime.toString());
};
